import React from 'react';

import './forgot-password.css';
import ForgotPasswordForm from './forgot-password-form';

type HomeProps = { mhqp: boolean };

const Home: React.FC<HomeProps> = ({ mhqp = false }) => {
    return (<div id={`forgot-password${mhqp ? '-mhqp' : ''}`}>
        <section className='pt-md-8 pb-md-4 pb-3 pt-8'>
            <div className='container mt-2 mt-md-5'>
                <div className='pt-lg-7 pb-lg-6'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-10 col-lg-7'>
                           <ForgotPasswordForm mhqp={mhqp} />
                        </div>
                    </div>
                </div>
            </div>       
        </section>
    </ div>);
};

export default Home;